// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K4Zq","col":"styles_col__QA2qr"};